export default {
  ko: {
    // 견적요청
    'REQUEST.TITLE.QUANTITY': '수량*',
    'REQUEST.PLACEHOLDER.QUANTITY': '수량 입력',
    'REQUEST.ERROR.QUANTITY': '수량을 입력해주세요.',

    'REQUEST.TITLE.DETAILEDSERVICE': '가공 방식*',
    'REQUEST.PLACEHOLDER.DETAILEDSERVICE': '가공 방식',
    'REQUEST.ERROR.DETAILEDSERVICE': '가공방식을 선택해주세요.',

    //CNC
    'REQUEST.CNC.TITLE.QUANTITY': '수량*',
    'REQUEST.CNC.PLACEHOLDER.QUANTITY': '수량 입력',
    'REQUEST.CNC.ERROR.QUANTITY': '수량을 입력해주세요.',

    'REQUEST.CNC.TITLE.DETAILEDSERVICE': '가공 방식*',
    'REQUEST.CNC.PLACEHOLDER.DETAILEDSERVICE': '가공 방식',
    'REQUEST.CNC.ERROR.DETAILEDSERVICE': '가공방식을 선택해주세요.',

    'REQUEST.CNC.TITLE.MATERIAL': '재료 대분류*',
    'REQUEST.CNC.PLACEHOLDER.MATERIAL': '재료 대분류',
    'REQUEST.CNC.ERROR.MATERIAL': '재료 대분류를 선택해주세요.',

    'REQUEST.CNC.TITLE.DETAILEDMATERIAL': '재료 소분류*',
    'REQUEST.CNC.PLACEHOLDER.DETAILEDMATERIAL': '재료 소분류',
    'REQUEST.CNC.ERROR.DETAILEDMATERIAL': '재료 소분류를 선택해주세요.',

    'REQUEST.CNC.TITLE.ETC': '기타 재료*',
    'REQUEST.CNC.PLACEHOLDER.ETC': '기타 재료를 입력해주세요.',
    'REQUEST.CNC.TITLE.DETAILED_REQUEST': '요청 사항',
    'REQUEST.CNC.ERROR.ETC': '기타 재료를 입력하세요.',
    'REQUEST.CNC.PLACEHOLDER.DETAILED_REQUEST':
      '제품 용도, 공차, 후가공과 같은 상세 가공 옵션이 필요할 시에 입력해주세요.',
    'REQUEST.CNC.ERROR.DETAILED_REQUEST':
      '파트너 추천을 선택한 경우, 요청사항 입력이 필수입니다.',

    //3DP
    'REQUEST.PRINTING.TITLE.QUANTITY': '수량*',
    'REQUEST.PRINTING.PLACEHOLDER.QUANTITY': '수량 입력',
    'REQUEST.PRINTING.ERROR.QUANTITY': '수량을 입력해주세요.',
    'REQUEST.PRINTING.TITLE.DETAILEDSERVICE': '가공 방식*',
    'REQUEST.PRINTING.PLACEHOLDER.DETAILEDSERVICE': '가공 방식',
    'REQUEST.PRINTING.ERROR.DETAILEDSERVICE': '가공방식을 선택해주세요.',
    'REQUEST.PRINTING.TITLE.MATERIAL': '재료*',
    'REQUEST.PRINTING.PLACEHOLDER.MATERIAL': '재료',
    'REQUEST.PRINTING.ERROR.MATERIAL': '재료를 선택해주세요.',
    'REQUEST.PRINTING.TITLE.DETAILED_REQUEST': '요청 사항',
    'REQUEST.PRINTING.TITLE.RECOMMEND_REQUEST_COMMENT': '요청 사항',
    'REQUEST.PRINTING.PLACEHOLDER.DETAILED_REQUEST':
      '공차, 조립성 검토, 도색 등 상세한 가공 요청이 필요할 시 요청사항에 입력해주세요. (업체의 추천이 필요한 경우, 가공 용도를 상세하게 적어주세요.)',
    'REQUEST.PRINTING.PLACEHOLDER.RECOMMEND_REQUEST_COMMENT':
      '공차, 조립성 검토, 도색 등 상세한 가공 요청이 필요할 시 요청사항에 입력해주세요. (업체의 추천이 필요한 경우, 가공 용도를 상세하게 적어주세요.)',
    'REQUEST.PRINTING.ERROR.DETAILED_REQUEST': '요청 사항을 입력해주세요.',
    'REQUEST.PRINTING.ERROR.RECOMMEND_REQUEST_COMMENT':
      '파트너 추천을 선택한 경우, 요청사항 입력이 필수입니다.',

    //Molding
    'REQUEST.MOLDING.TITLE.DETAILEDSERVICE': '사출 방식*',
    'REQUEST.MOLDING.PLACEHOLDER.DETAILEDSERVICE': '사출 방식',
    'REQUEST.MOLDING.ERROR.DETAILEDSERVICE': '사출 방식을 선택해주세요.',

    'REQUEST.MOLDING.TITLE.QUANTITY': '초도 수량*',
    'REQUEST.MOLDING.PLACEHOLDER.QUANTITY': '수량 입력',
    'REQUEST.MOLDING.ERROR.QUANTITY': '초도 수량을 입력해주세요.',

    'REQUEST.MOLDING.TITLE.MATERIAL': '재료 대분류*',
    'REQUEST.MOLDING.PLACEHOLDER.MATERIAL': '재료 대분류',
    'REQUEST.MOLDING.ERROR.MATERIAL': '재료 대분류를 선택해주세요.',

    'REQUEST.MOLDING.TITLE.DETAILEDMATERIAL': '재료 소분류*',
    'REQUEST.MOLDING.PLACEHOLDER.DETAILEDMATERIAL': '재료 소분류',
    'REQUEST.MOLDING.ERROR.DETAILEDMATERIAL': '재료 소분류를 선택해주세요.',

    'REQUEST.MOLDING.TITLE.ETC': '기타 재료*',
    'REQUEST.MOLDING.PLACEHOLDER.ETC': '기타 재료',
    'REQUEST.MOLDING.ERROR.ETC': '기타 재료를 입력해주세요.',
    'REQUEST.MOLDING.ERROR2.ETC': '기타 재료를 입력해주세요.',

    'REQUEST.MOLDING.TITLE.DETAILED_REQUEST': '상세 요청*',
    'REQUEST.MOLDING.PLACEHOLDER.DETAILED_REQUEST':
      '제품 용도, 표면 처리 등 상세한 가공 요청을 입력해주세요. (요청 사항이 상세할 수록, 업체의 정확한 답변을 받을 확률이 높아집니다.)',
    'REQUEST.MOLDING.ERROR.DETAILED_REQUEST':
      '파트너 추천을 선택한 경우, 요청사항 입력이 필수입니다.',
    'REQUEST.MOLDING.ERROR2.DETAILED_REQUEST': '상세 사항을 입력해주세요.',
    'REQUEST.ERROR.DETAILED_REQUEST': '상세 사항을 입력해주세요.',

    //SHEETING
    'REQUEST.SHEETING.TITLE.QUANTITY': '수량*',
    'REQUEST.SHEETING.PLACEHOLDER.QUANTITY': '수량 입력',
    'REQUEST.SHEETING.ERROR.QUANTITY': '수량을 입력해주세요.',

    'REQUEST.SHEETING.TITLE.DETAILEDSERVICE': '가공방식*',
    'REQUEST.SHEETING.PLACEHOLDER.DETAILEDSERVICE': '가공방식',
    'REQUEST.SHEETING.ERROR.DETAILEDSERVICE': '가공방식을 선택해주세요.',

    'REQUEST.SHEETING.TITLE.MATERIAL': '재료*',
    'REQUEST.SHEETING.PLACEHOLDER.MATERIAL': '재료',
    'REQUEST.SHEETING.ERROR.MATERIAL': '재료를 선택해주세요.',

    'REQUEST.SHEETING.TITLE.ETC': '기타 재료*',
    'REQUEST.SHEETING.PLACEHOLDER.ETC': '기타 재료',
    'REQUEST.SHEETING.ERROR.ETC': '기타 재료를 입력해주세요.',
    'REQUEST.SHEETING.ERROR2.ETC': '기타 재료를 입력해주세요.',

    'REQUEST.SHEETING.TITLE.DETAILED_REQUEST': '요청 사항',
    'REQUEST.SHEETING.TITLE.RECOMMEND_REQUEST_COMMENT': '요청 사항',
    'REQUEST.SHEETING.PLACEHOLDER.DETAILED_REQUEST':
      '공차, 조립성 검토, 도색 등 상세한 가공 요청이 필요할 시 요청사항에 입력해주세요. (업체의 추천이 필요한 경우, 가공 용도를 상세하게 적어주세요.)',
    'REQUEST.SHEETING.PLACEHOLDER.RECOMMEND_REQUEST_COMMENT':
      '공차, 조립성 검토, 도색 등 상세한 가공 요청이 필요할 시 요청사항에 입력해주세요. (업체의 추천이 필요한 경우, 가공 용도를 상세하게 적어주세요.)',
    'REQUEST.SHEETING.ERROR.DETAILED_REQUEST': '요청 사항을 입력해주세요.',
    'REQUEST.SHEETING.ERROR.RECOMMEND_REQUEST_COMMENT':
      '파트너 추천을 선택한 경우, 요청사항 입력이 필수입니다.',

    //3DP
    'REQUEST.CASTING.TITLE.QUANTITY': '수량*',
    'REQUEST.CASTING.PLACEHOLDER.QUANTITY': '수량 입력',
    'REQUEST.CASTING.ERROR.QUANTITY': '수량을 입력해주세요.',
    'REQUEST.CASTING.TITLE.DETAILEDSERVICE': '가공 방식*',
    'REQUEST.CASTING.PLACEHOLDER.DETAILEDSERVICE': '가공 방식',
    'REQUEST.CASTING.ERROR.DETAILEDSERVICE': '가공방식을 선택해주세요.',
    'REQUEST.CASTING.TITLE.MATERIAL': '재료*',
    'REQUEST.CASTING.PLACEHOLDER.MATERIAL': '재료',
    'REQUEST.CASTING.ERROR.MATERIAL': '재료를 선택해주세요.',
    'REQUEST.CASTING.TITLE.DETAILED_REQUEST': '요청 사항',
    'REQUEST.CASTING.TITLE.RECOMMEND_REQUEST_COMMENT': '요청 사항',
    'REQUEST.CASTING.PLACEHOLDER.DETAILED_REQUEST':
      '공차, 조립성 검토, 도색 등 상세한 가공 요청이 필요할 시 요청사항에 입력해주세요. (업체의 추천이 필요한 경우, 가공 용도를 상세하게 적어주세요.)',
    'REQUEST.CASTING.PLACEHOLDER.RECOMMEND_REQUEST_COMMENT':
      '공차, 조립성 검토, 도색 등 상세한 가공 요청이 필요할 시 요청사항에 입력해주세요. (업체의 추천이 필요한 경우, 가공 용도를 상세하게 적어주세요.)',
    'REQUEST.CASTING.ERROR.DETAILED_REQUEST': '요청 사항을 입력해주세요.',
    'REQUEST.CASTING.ERROR.RECOMMEND_REQUEST_COMMENT':
      '파트너 추천을 선택한 경우, 요청사항 입력이 필수입니다.',
    //
    'REQUEST.TITLE.PROJECTNAME': '프로젝트명 *',
    'REQUEST.PLACEHOLDER.PROJECTNAME': '예) 청소용 가전제품 내부 부품 가공',
    'REQUEST.ERROR.PROJECTNAME': '프로젝트명을 입력해주세요.',

    'REQUEST.TITLE.DUEDATE': '납기일 *',
    'REQUEST.PLACEHOLDER.DUEDATE': '납기일을 선택해주세요',
    'REQUEST.ERROR.DUEDATE': '납기일을 선택해주세요.',

    'REQUEST.TITLE.MANAGERNAME': '이름 *',
    'REQUEST.PLACEHOLDER.MANAGERNAME': '이름',
    'REQUEST.ERROR.MANAGERNAME': '이름을 입력해주세요.',

    'REQUEST.TITLE.EMAIL': '이메일 *',
    'REQUEST.PLACEHOLDER.EMAIL': '이메일',
    'REQUEST.ERROR.EMAIL': '이메일을 입력해주세요.',

    'REQUEST.TITLE.COMPANY_NAME': '회사명 *',
    'REQUEST.PLACEHOLDER.COMPANY_NAME': '회사명',
    'REQUEST.ERROR.COMPANY_NAME': '회사명을 입력해주세요.',

    'REQUEST.ERROR.PHONE_NUMBER': '휴대전화 번호를 입력해주세요.',

    'REQUEST.ERROR.INFLOW_ROUTE': '유입 경로를 1개 이상 선택해주세요.',

    'REQUEST.ERROR.SMS_AGREE': '개인정보 수집 및 활용에 동의해주세요.',

    // 로그인
    'LOGIN.TITLE.EMAIL': '이메일 *',
    'LOGIN.PLACEHOLDER.EMAIL': '이메일',
    'LOGIN.ERROR.EMAIL': '이메일을 입력해주세요.',

    'LOGIN.TITLE.PASSWORD': '비밀번호 *',
    'LOGIN.PLACEHOLDER.PASSWORD': '비밀번호',
    'LOGIN.ERROR.PASSWORD': '비밀번호를 입력해주세요.',

    // 회원가입
    'JOIN.TITLE.EMAIL': '이메일 *',
    'JOIN.PLACEHOLDER.EMAIL': '이메일',
    'JOIN.ERROR.EMAIL': '이메일을 입력해주세요.',

    'JOIN.TITLE.PASSWORD': '비밀번호 *',
    'JOIN.PLACEHOLDER.PASSWORD': '영문+숫자 혼용 8글자 이상',
    'JOIN.ERROR.PASSWORD': '비밀번호를 입력해주세요.',

    'JOIN.TITLE.PASSWORDCONFIRM': '비밀번호 확인 *',
    'JOIN.PLACEHOLDER.PASSWORDCONFIRM': '비밀번호 확인',
    'JOIN.ERROR.PASSWORDCONFIRM': '비밀번호와 동일한 값을 입력해주세요.',

    'JOIN.TITLE.MANAGERNAME': '이름 *',
    'JOIN.PLACEHOLDER.MANAGERNAME': '이름',
    'JOIN.ERROR.MANAGERNAME': '이름을 입력해주세요.',

    'JOIN.TITLE.CELLPHONENUMBER': '휴대 전화 *',
    'JOIN.PLACEHOLDER.CELLPHONENUMBER': 'ex) 01012341234',
    'JOIN.ERROR.CELLPHONENUMBER': '휴대전화번호는 11자리 숫자로 입력해주세요.',

    'JOIN.TITLE.ORGANIZATIONNAME': '회사명 *',
    'JOIN.PLACEHOLDER.ORGANIZATIONNAME': '회사명',
    'JOIN.ERROR.ORGANIZATIONNAME': '회사/단체명을 입력해주세요.',

    'JOIN.TITLE.COMPANYREGISTRATIONNUMBER': '사업자등록번호 *',
    'JOIN.PLACEHOLDER.COMPANYREGISTRATIONNUMBER': '사업자등록번호',
    'JOIN.ERROR.COMPANYREGISTRATIONNUMBER': '숫자만 입력해주세요.',

    'JOIN.TITLE.FULLADDRESS': '주소 *',
    'JOIN.PLACEHOLDER.FULLADDRESS': '주소',
    'JOIN.ERROR.FULLADDRESS': '주소를 입력해주세요.',

    'JOIN.TITLE.WEBSITE': '웹사이트',
    'JOIN.PLACEHOLDER.WEBSITE': '웹사이트',
    'JOIN.ERROR.WEBSITE': '웹사이트를 입력해주세요.',

    'JOIN.TITLE.COMPANYINTRODUCTION': '소개글',
    'JOIN.PLACEHOLDER.COMPANYINTRODUCTION': '소개글',
    'JOIN.ERROR.COMPANYINTRODUCTION': '소개글을 입력해주세요.',

    // 계정정보 수정

    'CONFIG.TITLE.PASSWORD_CURRENT': '현재 비밀번호',
    'CONFIG.PLACEHOLDER.PASSWORD_CURRENT': '현재 비밀번호',
    'CONFIG.ERROR.PASSWORD_CURRENT': '현재 비밀번호를 입력해주세요.',

    'CONFIG.TITLE.PASSWORD_NEW': '새 비밀번호',
    'CONFIG.PLACEHOLDER.PASSWORD_NEW': '영문+숫자 혼용 8글자 이상',
    'CONFIG.ERROR.PASSWORD_NEW': '비밀번호를 입력해주세요',

    'CONFIG.TITLE.PASSWORD_CONFIRM': '재입력',
    'CONFIG.PLACEHOLDER.PASSWORD_CONFIRM': '비밀번호 다시 입력',
    'CONFIG.ERROR.PASSWORD_CONFIRM': '새 비밀번호와 동일한 값을 입력해주세요.',

    'CONFIG.TITLE.CELLPHONENUMBER': '휴대 전화',
    'CONFIG.PLACEHOLDER.CELLPHONENUMBER': 'ex) 01012341234',
    'CONFIG.ERROR.CELLPHONENUMBER':
      '휴대전화번호는 11자리 숫자로 입력해주세요.',

    'CONFIG.TITLE.MANAGERNAME': '이름',
    'CONFIG.PLACEHOLDER.MANAGERNAME': '이름',
    'CONFIG.ERROR.MANAGERNAME': '이름을 입력해주세요.',

    'CONFIG.TITLE.ORGANIZATIONNAME': '회사명',
    'CONFIG.PLACEHOLDER.ORGANIZATIONNAME': '회사명',
    'CONFIG.ERROR.ORGANIZATIONNAME': '회사명을 입력해주세요.'
  }
};
